import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(
  () => ({
    searchInput: {
      position: 'relative',
      width: 'fit-content',
      height: '32px',
    },
    searchIcon: {
      zIndex: 10,
    },
  }),
  { name: 'SearchInput' },
);

export default useStyles;
